var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsAmplify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_22264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.52875 22.4541H14.9788L17.1425 26.2628H0L6.01875 15.8328L8.54125 11.4653L10.7075 15.2178L6.52875 22.4541ZM9.67875 9.49031L11.76 5.88531L23.5287 26.2616H19.3612L9.67875 9.49031ZM12.9163 3.88281H17.0788L30 26.2628H25.8325L12.9163 3.88281Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_22264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsAmplify);
export default __webpack_public_path__ + "static/media/awsAmplify.b8c0d892bd532976583dd6441cdacc3b.svg";
export { ForwardRef as ReactComponent };